// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/home/m_bg_slide_01.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/images/home/m_bg_slide_02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/assets/images/home/m_bg_slide_03.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/assets/images/home/bg_slide_01.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/assets/images/home/bg_slide_02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/assets/images/home/bg_slide_03.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.swiper.swipper-initialized {
  overflow: hidden;
}
.main > .swiper-wrapper {
  display: block;
  /* flex-direction: column; */
}
.swiper-vertical > .swiper-wrapper {
  height: 100%;
}
.main.swiper-wrapper {
  display: block;
}
.main > .swiper-wrapper > .swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  width: 100%;
  height: 100%;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}
.main > .swiper-wrapper > .swiper-slide > div {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
.slide01 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center
    no-repeat;
  background-size: cover;
}
.slide02 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center
    no-repeat;
  background-size: cover;
}
.slide03 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center
    no-repeat;
  background-size: cover;
}
@media (min-width: 1024px) {
  .slide01 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center
      no-repeat;
    background-size: cover;
  }
  .slide02 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center center
      no-repeat;
    background-size: cover;
  }
  .slide03 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) center center
      no-repeat;
    background-size: cover;
  }
}
.swiper-slide .visual {
  height: 100vh;
}
.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets {
  right: calc(100% - 80px);
  left: var(--swiper-pagination-left, auto);
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}
.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 23px 0;
}
.swiper-pagination-bullet {
  display: inline-block;
  width: 14px;
  height: 14px;

  background: #fff;
  opacity: 0.3;
  transition: 0.3s;
}
.swiper-pagination {
  display: none;
}
.swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
}
@media (min-width: 1024px) {
  .swiper-backface-hidden .swiper-slide {
    height: 100%;
  }
  .main > .swiper-wrapper > .swiper-slide,
  .main > .swiper-wrapper > .swiper-slide > div {
    height: 100%;
  }
  .swiper-pagination {
    display: block;
  }
}

.visual .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  border: 1px solid #fff;
  background: none;
  opacity: 1;

  transition: 0.3s;
}
.swiper-fade .swiper-slide {
  overflow: hidden;
}
.visual .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 16px;
  background: #fff;
  opacity: 1;
  border-radius: 10px;
}
.swiper-slide.footer {
  height: 200px !important;
}

.main > .swiper-wrapper > .visual .scroll {
  overflow: hidden;
  position: absolute;
  left: 50%;
  bottom: 85px;
  z-index: 100;
  width: 2px;
  height: 83px;
  background: rgba(255, 255, 255, 0.3);
}
.main > .swiper-wrapper > .visual .scroll:after {
  display: block;
  content: '';
  width: 2px;
  height: 34px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  animation: scroll 1s infinite ease;
}
@media (min-width: 1024px) {
  .main > .swiper-wrapper > .visual .scroll {
    bottom: 220px;
  }
}
@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(150%);
  }
}

.visual-slide .bg {
  transform: scale(1.1);
  transition: all 1.4s;
}
.visual-slide .swiper-slide-active .bg {
  transform: scale(1);
}
`, "",{"version":3,"sources":["webpack://./src/swiper.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE;aACW;EACX,sBAAsB;AACxB;AACA;EACE;aACW;EACX,sBAAsB;AACxB;AACA;EACE;aACW;EACX,sBAAsB;AACxB;AACA;EACE;IACE;eACW;IACX,sBAAsB;EACxB;EACA;IACE;eACW;IACX,sBAAsB;EACxB;EACA;IACE;eACW;IACX,sBAAsB;EACxB;AACF;AACA;EACE,aAAa;AACf;AACA;;EAEE,wBAAwB;EACxB,yCAAyC;EACzC,QAAQ;EACR,oCAAoC;AACtC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;;EAEV,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,kCAAkC;AACpC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".swiper {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.swiper.swipper-initialized {\n  overflow: hidden;\n}\n.main > .swiper-wrapper {\n  display: block;\n  /* flex-direction: column; */\n}\n.swiper-vertical > .swiper-wrapper {\n  height: 100%;\n}\n.main.swiper-wrapper {\n  display: block;\n}\n.main > .swiper-wrapper > .swiper-slide {\n  text-align: center;\n  font-size: 18px;\n  background: #fff;\n  width: 100%;\n  height: 100%;\n  /* Center slide text vertically */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.main > .swiper-wrapper > .swiper-slide > div {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n.slide01 {\n  background: url('/public/assets/images/home/m_bg_slide_01.jpg') center center\n    no-repeat;\n  background-size: cover;\n}\n.slide02 {\n  background: url('/public/assets/images/home/m_bg_slide_02.jpg') center center\n    no-repeat;\n  background-size: cover;\n}\n.slide03 {\n  background: url('/public/assets/images/home/m_bg_slide_03.jpg') center center\n    no-repeat;\n  background-size: cover;\n}\n@media (min-width: 1024px) {\n  .slide01 {\n    background: url('/public/assets/images/home/bg_slide_01.jpg') center center\n      no-repeat;\n    background-size: cover;\n  }\n  .slide02 {\n    background: url('/public/assets/images/home/bg_slide_02.jpg') center center\n      no-repeat;\n    background-size: cover;\n  }\n  .slide03 {\n    background: url('/public/assets/images/home/bg_slide_03.jpg') center center\n      no-repeat;\n    background-size: cover;\n  }\n}\n.swiper-slide .visual {\n  height: 100vh;\n}\n.swiper-vertical > .swiper-pagination-bullets,\n.swiper-pagination-vertical.swiper-pagination-bullets {\n  right: calc(100% - 80px);\n  left: var(--swiper-pagination-left, auto);\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets\n  .swiper-pagination-bullet {\n  margin: 23px 0;\n}\n.swiper-pagination-bullet {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n\n  background: #fff;\n  opacity: 0.3;\n  transition: 0.3s;\n}\n.swiper-pagination {\n  display: none;\n}\n.swiper-pagination-bullet.swiper-pagination-bullet-active {\n  opacity: 1;\n}\n@media (min-width: 1024px) {\n  .swiper-backface-hidden .swiper-slide {\n    height: 100%;\n  }\n  .main > .swiper-wrapper > .swiper-slide,\n  .main > .swiper-wrapper > .swiper-slide > div {\n    height: 100%;\n  }\n  .swiper-pagination {\n    display: block;\n  }\n}\n\n.visual .swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  border: 1px solid #fff;\n  background: none;\n  opacity: 1;\n\n  transition: 0.3s;\n}\n.swiper-fade .swiper-slide {\n  overflow: hidden;\n}\n.visual .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 16px;\n  background: #fff;\n  opacity: 1;\n  border-radius: 10px;\n}\n.swiper-slide.footer {\n  height: 200px !important;\n}\n\n.main > .swiper-wrapper > .visual .scroll {\n  overflow: hidden;\n  position: absolute;\n  left: 50%;\n  bottom: 85px;\n  z-index: 100;\n  width: 2px;\n  height: 83px;\n  background: rgba(255, 255, 255, 0.3);\n}\n.main > .swiper-wrapper > .visual .scroll:after {\n  display: block;\n  content: '';\n  width: 2px;\n  height: 34px;\n  background: #fff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  animation: scroll 1s infinite ease;\n}\n@media (min-width: 1024px) {\n  .main > .swiper-wrapper > .visual .scroll {\n    bottom: 220px;\n  }\n}\n@keyframes scroll {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(150%);\n  }\n}\n\n.visual-slide .bg {\n  transform: scale(1.1);\n  transition: all 1.4s;\n}\n.visual-slide .swiper-slide-active .bg {\n  transform: scale(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
